import { arrow } from '@rootCommon/images';
import Avatar from '@rootCommon/components/avatar';

type Props = {
  username: string | null;
  avatarId?: number | null;
};

const MenuTrigger = ({ username, avatarId }: Props): JSX.Element => (
  <div className="user-auth">
    <div className="user-auth__img">
      <Avatar className={avatarId ? '' : 'empty'} fileId={avatarId} alt="avatar" />
    </div>
    <div className="user-auth__name">{username}</div>
    <div className="user-auth__arrow">
      <img src={arrow} alt="" />
    </div>
  </div>
);

export default MenuTrigger;
